window.addEventListener('load', () => {

    let successMsg = document.querySelector('#CustomAddProductForm_Form_error');
    let warningMsg = document.querySelector('.product-warning-msg');

    if (successMsg) {
        if (successMsg.classList.contains('good')) {
            if (warningMsg) {
                warningMsg.style.display = 'block';
            }
        }
    }
});